import apiHelpers from '@/utils/api'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AxiosPromise } from 'axios'
import { AloMailSkin,cleanAloMailSkin } from '@/models/alo/AloMailSkin'

export default {
  getAllMailSkin(): AxiosPromise<AlrContainer<Array<AloMailSkin>>> {    
    return apiHelpers.apiCall({ 
      url: `/webapi/MailSkin`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloMailSkin>>
      }]
    })
  },
  getMailSkin(id:number):AxiosPromise<AlrContainer<AloMailSkin>> {
    return  apiHelpers.apiCall({ 
      url: `/webapi/MailSkin/${id}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloMailSkin>
      }]
    })
  },
  saveMailSkin(mailSkin:AloMailSkin):AxiosPromise<AlrContainer<AloMailSkin>> {
    cleanAloMailSkin(mailSkin)
    if(mailSkin.id) {
      return  apiHelpers.apiCall({ 
        url: `/webapi/MailSkin/${mailSkin.id}`, 
        method: 'PUT',
        data: mailSkin,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloMailSkin>
        }]
      })    
    }
    else{
      return  apiHelpers.apiCall({ 
        url: `/webapi/MailSkin`, 
        method: 'POST',
        data: mailSkin,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloMailSkin>
        }]
      })    
    }
  },
  deleteMailSkin(id:number):AxiosPromise<AlrContainer<AloMailSkin>>{
    return  apiHelpers.apiCall({ 
      url: `/webapi/MailSkin/${id}`, 
      method: 'DELETE',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloMailSkin>
      }]
    })
  }
}